import { useContext } from 'react'

import { BrandCategoryPageDesktopContext } from './context'

export const useBrandCategoryPageDesktop = () => {
  const context = useContext(BrandCategoryPageDesktopContext)

  if (!context) {
    throw new Error('useBrandCategoryPageDesktop must be used within a BrandCategoryPageDesktopProvider')
  }

  return context
}
